import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import web5 from "../img/trans1.jpg";
import web1 from "../img/wlt.jpg";

import "../style/styles.css";
import "../style/Transport.css";

const Transport = () => {
  let alText = "Photo";

  const quickStats = [
    { value: "Multi", label: "Branching" },
    { value: "CN", label: "Consignment Note" },
    { value: "Manifest", label: "Incoming / Outgoing" },
    { value: "A/c", label: "Finance & Accounts" },
  ];

  const keyModules = [
    {
      title: "Key features(Entry Module)",
      text:
        "Create locations, manage consignor and consignee customers, generate consignment note entries, manifests, delivery tracking, money receipts, lorry hire challans and periodical billing.",
    },
    {
      title: "Reports HUB",
      text:
        "Booking and transshipment details, incoming/outgoing manifests, run-sheet preparation, dispatch, delivery, vendor payments, customer receipts and website tracking.",
    },
    {
      title: "Accounting Reports",
      text:
        "Cash bank book, journal book, debit note, credit note, purchase, sales, ledger, trial balance, expense trial, profit and loss, reconciliation and cost centre reports.",
    },
    {
      title: "MIS Reports",
      text:
        "Supplier-wise product purchase register, supplier-wise monthly product purchase report, department-wise store consumption reports and pending purchase order register.",
    },
    {
      title: "Branch & Location Control",
      text:
        "Bookings and delivery service location and branch creation with incoming, outgoing manifest and receiving/booking reports.",
    },
    {
      title: "Delivery & Tracking",
      text:
        "Track pending delivery, delivered items, load handling report, delivery status of manifest and tracking option on website.",
    },
  ];

  const entryFeatures = [
    "Create new Location/Place Entries of your business according to your needs.",
    "Separate Customers on the basis of Consignor or Consignee",
    "Generate Consignment Note Entry with Receipt Print",
    "Generate Manifest for the consignment.",
    "Track pending Delivery / Delivered items",
    "Generate Money Receipt (Consignment Entry Wise)",
    "Generate Lorry Hire Challan.",
    "View detailed overview of generated and pending money receipt.",
    "View detailed overview of generated and delivery status of manifest.",
    "Generate Billing on Periodical",
  ];

  const accountingReports = [
    "Cash Bank Book",
    "Journal Book",
    "Debit Note Register",
    "Credit Note Register",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Expense Trial",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Statement of Expenditure",
    "Cost Centre Reports",
  ];

  const misReports = [
    "Supplier Wise Product Purchase Register",
    "Supplier Wise Monthly Product Purchase Report",
    "Department Wise Store Consumption Reports",
    "Pending Purchase Order Register",
  ];

  const reportsHub = [
    "Booking & Transshipment Details",
    "Outgoing, Incoming Manifest",
    "Run-sheet Preparation & Updating",
    "Bookings, Dispatch and Delivery",
    "Vendor Management for payments",
    "Customer receipts",
    "Provide tracking option on website",
    "Finance & Accounts Management",
    "Bookings & Delivery Service Location and Branch creation",
    "Incoming, Outgoing Manifest",
    "Receiving and booking Report",
    "Load Handling Report",
  ];

  const overviewItems = [
    "Goods/Courier Transportation Service",
    "Web application with multi branching",
    "Consignment note with receipt print",
    "Manifest generation",
    "Pending and delivered item tracking",
    "Money receipt",
    "Lorry hire challan",
    "Periodical billing",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="transport-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          TransportPro - Transport Management System | EBS Software Solution
        </title>
        <meta
          name="description"
          content="TransportPro is a transport management web application with multi branching, location entry, consignor and consignee management, consignment note, manifest, delivery tracking, money receipt, lorry hire challan, periodical billing, reports hub, accounting and MIS reports."
        />
      </Helmet>

      <section className="transport-hero">
        <img
          className="transport-hero-bg"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="transport-hero-overlay"></div>

        <Container className="transport-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="transport-hero-content">
                <div className="transport-kicker">Transport Management Software</div>
                <h1>TransportPro</h1>
                <h2>Software for Transport Management System</h2>
                <p>
                  Transportation is one of the biggest sector now-a-days
                  specially Goods/Courier Transportation Service. Transportation
                  indirectly affects the development of a society. Get your
                  transportation to new heights with our full featured
                  application.
                </p>

                <div className="transport-hero-actions">
                  <a href="#transport-modules" className="transport-btn transport-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="transport-btn transport-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="transport-highlight-card">
                <span>Web application with multi branching</span>
                <strong>Booking + Manifest + Delivery + Finance</strong>
                <p>
                  A complete transport solution for goods and courier service
                  operations with branch, location, booking, delivery and
                  accounting control.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="transport-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="transport-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="transport-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="transport-section-label">Overview</div>
              <h2 className="transport-section-title">
                Full-featured transport web application with multi branching
              </h2>
              <p className="transport-text">
                TransportPro is designed for goods and courier transportation
                services to manage location entries, consignor and consignee
                customers, consignment notes, manifests, delivery tracking,
                money receipts, lorry hire challans and periodical billing.
              </p>
              <p className="transport-text">
                The system helps manage booking, transshipment, dispatch,
                delivery, vendor payments, customer receipts, finance, accounts,
                branch creation and reporting from one organized platform.
              </p>
            </Col>

            <Col lg={6}>
              <div className="transport-overview-card">
                <h3>TransportPro covers</h3>
                <div className="transport-overview-grid">
                  {overviewItems.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="transport-modules-section" id="transport-modules">
        <Container>
          <div className="transport-heading-center">
            <div className="transport-section-label">Key Modules</div>
            <h2 className="transport-section-title">
              Complete workflow from booking to finance and accounts
            </h2>
            <p>
              TransportPro connects location setup, customer management,
              consignment, manifest, delivery, billing, reports hub, accounting
              and MIS reports in one transport management system.
            </p>
          </div>

          <Row className="g-4">
            {keyModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="transport-module-card">
                  <div className="transport-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="transport-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="transport-list-card">
                <div className="transport-section-label">Entry Module</div>
                <h2>Key features(Entry Module)</h2>
                <ul>
                  {entryFeatures.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="transport-list-card transport-list-card-dark">
                <div className="transport-section-label">Reports HUB</div>
                <h2>Reports HUB</h2>
                <ul>
                  {reportsHub.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="transport-feature-list-section transport-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={7}>
              <div className="transport-list-card">
                <div className="transport-section-label">Accounting Reports</div>
                <h2>Accounting Reports</h2>
                <ul>
                  {accountingReports.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={5}>
              <div className="transport-side-stack">
                <div className="transport-list-card">
                  <div className="transport-section-label">MIS Reports</div>
                  <h2>MIS Reports</h2>
                  <ul>
                    {misReports.map((item) => (
                      <li key={item}>
                        <span>✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="transport-image-card">
                  <img
                    src={web1}
                    alt={alText}
                    onError={handleImageError}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="transport-cta-section">
        <Container>
          <div className="transport-cta-card">
            <div>
              <span>Ready to manage transport operations professionally?</span>
              <h2>Use TransportPro for booking, manifest, delivery and accounts.</h2>
              <p>
                Get a complete transport management web application with multi
                branching, consignment, manifest, delivery tracking, billing,
                reports hub, accounting and MIS reports.
              </p>
            </div>
            <Link to="/EmailContactForm" className="transport-btn transport-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Transport;
